/* eslint-disable */
import "./style.scss";
import React, { useCallback, useEffect, useState } from "react";
import { Button, Select, Table, Tag, Spin, Input } from "antd";
import { ColumnsType } from "antd/es/table";

import ApiService from "@services/api.service";
import moment from "moment";
import { cloneDeep, remove, uniqBy } from "lodash";
import { toast } from "react-toastify";

import { useOutletContext } from "react-router-dom";
import { SearchOutlined } from "@ant-design/icons";
import { DeleteOutlined } from "@ant-design/icons";

interface DataType {
  key: React.Key;
  name: string;
  age: number;
  address: string;
}
interface PracticeOption {
  value: number;
  label: string;
}

const { Option } = Select;
function CancelledSurvey() {
  const [searchResults, setSearchResults] = useState<any>([]);
  const [tempSearchResults, setTempSearchResults] = useState<any>([]);
  const [medicalPractices, setMedicalPractices] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDropdownValue, setSelectDropdownValue] = useState<string>();
  const [usersColumns, setUsersColumns] = useState<ColumnsType<DataType>>();
  const [currentUser, setCurrentUser]: any = useState();

  const [title, setTitle] = useState<string>();
  const [total, setTotal] = useState<number>(0);
  const [rerender, setRerender] = useState<boolean>(false);
  const [toggleAccessLoading, setToggleAccessLoading] = useState<null | number>(
    null
  );
  const { user }: any = useOutletContext();
  const [sort, setSort] = useState({
    field: "name",
    order: "asc", // 'ascend' or 'descend'
  });
  var columns: ColumnsType<DataType>;
  const [data, setData] = useState<PracticeOption[]>([]);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [search, setSearch] = useState(false);
  const [ascSort, setAcsSort] = useState(false);
  const [desSort, setDesSort] = useState(false);

  columns = [
    {
      title: "ID",
      width: 80,
      dataIndex: "id",
      key: "id",
      sorter: true,
    },
    {
      title: "Medical Practice ID",
      width: 200,
      key: "medicalPracticeId",
      render: (row) => {
        return row?.medicalPracticeId;
      },
      sorter: true,
    },
    {
      title: "Name",
      key: "name",
      render: (row) => {
        return row.profile?.name;
      },
      sorter: true,
    },
    {
      title: "Surname",
      key: "surname",
      render: (row) => {
        return row.profile?.surname;
      },
      sorter: true,
    },
    {
      title: "Practice Name",
      key: "practiceName",
      render: (row) => {
        return row?.medicalPractice?.practiceName;
      },
      sorter: true,
    },
    {
      title: "Survey Data",
      key: "SurveyData",
      dataIndex: "surveyData",
      render: (row) => {
        console.log("Data " + row);
        if (!row) return "-";
        let parsedSurveyData: any = {};
        try {
          parsedSurveyData = JSON.parse(row);
        } catch {
          return "Invalid survey data";
        }
        const sortedEntries = Object.entries(parsedSurveyData).sort(
          ([keyA], [keyB]) => {
            if (keyA === "primaryreason") return -1;
            if (keyB === "primaryreason") return 1;
            return 0;
          }
        );
        return (
          <div>
            {sortedEntries.map(([question, answer]: any, index) => (
              <div key={index} style={{ marginBottom: "12px" }}>
                <div
                  style={{
                    fontWeight: 600,
                    marginBottom: 4,
                    color: "#1677ff",
                  }}
                >
                  {question === "primaryreason"
                    ? "Primary Reason:"
                    : `${question.replace(/<br\s*\/?>/gi, " ")}:`}
                </div>

                <div style={{ color: "#555" }}>{answer}</div>
              </div>
            ))}
          </div>
        );
      },
      sorter: true,
    },
  ];

  useEffect(() => {
    setUsersColumns(columns);
  }, []);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [paginationPractice, setPaginationPractice] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchData = async (
    page: any,
    pageSize: any,
    sortField: any,
    sortOrder: any,
    search = ""
  ) => {
    if ((!hasMore || loading) && search === "") return;
    setLoading(true);
    ApiService.getCancelledSurvey(
      page,
      pageSize,
      "id",
      { id: "asc" },
      Number(selectedDropdownValue),
      search
    )
      .then((response) => {
        if (response?.data?.surveys?.data) {
          const source = response?.data?.surveys?.data ?? [];
          const mapped: PracticeOption[] = source
            .filter(
              (item: any) =>
                item?.medicalPracticeId && item?.medicalPractice?.practiceName
            )
            .map(
              (item: any): PracticeOption => ({
                value: Number(item.medicalPracticeId),
                label: String(item.medicalPractice.practiceName).trim(),
              })
            );
          const newData = uniqBy(mapped, "value");

          console.log(
            "getcancelledSurvey Medicalpractices" + JSON.stringify(newData)
          );
          setPaginationPractice((prev) => ({
            ...prev,
            current: page + 1,
            total: response?.data?.surveys?.total,
          }));
          if (search) {
            setData(newData);
          } else {
            setData((prevData): any => [...prevData, ...newData]);
            setHasMore(newData.length > 0); // If no new data, stop loading
          }
          setPage(page + 1);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const handlePopupScroll = (e: any) => {
    const { target } = e;
    if (target.scrollTop + target.clientHeight >= target.scrollHeight - 10) {
      fetchData(
        paginationPractice.current,
        paginationPractice.pageSize,
        sort.field,
        sort.order
      );
    }
  };

  useEffect(() => {
    fetchCancelledPractices(
      pagination.current,
      pagination.pageSize,
      sort.field,
      sort.order
    );
    fetchData(
      paginationPractice.current,
      paginationPractice.pageSize,
      sort.field,
      sort.order
    );
    // fetchActivePractices();
  }, []);
  // Load initial data on mount
  // Function to fetch more data

  function fetchCancelledPractices(
    page: any,
    pageSize: any,
    sortField: any,
    sortOrder: any
  ) {
    setIsLoading(true);
    ApiService.getCancelledSurvey(
      page,
      pageSize,
      sortField,
      sortOrder,
      Number(selectedDropdownValue),
      searchText
    )
      .then((response) => {
        if (response?.data) {
          setSearchResults(response?.data?.surveys?.data);
          setTempSearchResults(response?.data?.surveys?.data);
          setTotal(response.data.surveys?.total);
          setPagination((prev) => ({
            ...prev,
            current: page,
            total: response.data.surveys?.total,
          }));
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }

  const handleChange = (value: string) => {
    setSelectDropdownValue(value);
    setPagination((prev) => ({
      ...prev,
      current: 1,
    }));
  };
  useEffect(() => {
    if (selectedDropdownValue) {
      fetchCancelledPractices(
        pagination.current,
        pagination.pageSize,
        "id",
        "asc"
      );
    }
    if (selectedDropdownValue === undefined) {
      setData([]);
      fetchData(1, paginationPractice.pageSize, sort.field, sort.order);
      fetchCancelledPractices(1, pagination.pageSize, "id", "asc");
    }
  }, [selectedDropdownValue]);

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    let rem = 0;
    if (sorter.column === undefined) {
      setSort({ field: "name", order: "asc" });
      fetchCancelledPractices(
        pagination.current,
        pagination.pageSize,
        "name",
        "asc"
      );
      setDesSort(false);
      setAcsSort(false);
    } else {
      if (sorter.order === "descend") {
        if (desSort === false) {
          fetchCancelledPractices(
            1,
            pagination.pageSize,
            sorter.column.key,
            "desc"
          );
          setDesSort(true);
        } else {
          if (sorter.column.key !== sort.field) {
            fetchCancelledPractices(
              1,
              pagination.pageSize,
              sorter.column.key,
              "desc"
            );
          } else {
            fetchCancelledPractices(
              pagination.current,
              pagination.pageSize,
              sorter.column.key,
              "desc"
            );
          }
        }
        setSort({ field: sorter.column.key, order: sorter.order });
      }
      if (sorter.order === "ascend") {
        if (ascSort === false) {
          fetchCancelledPractices(
            1,
            pagination.pageSize,
            sorter.column.key,
            "asc"
          );
          setAcsSort(true);
        } else {
          if (sorter.column.key !== sort.field) {
            fetchCancelledPractices(
              1,
              pagination.pageSize,
              sorter.column.key,
              "asc"
            );
          } else {
            fetchCancelledPractices(
              pagination.current,
              pagination.pageSize,
              sorter.column.key,
              "asc"
            );
          }
        }
        setSort({ field: sorter.column.key, order: sorter.order });
      }
    }
  };
  let debounceTimer: ReturnType<typeof setTimeout>;
  const roleBasedColumns: any = {
    3: columns, // Admin sees all
    4: columns.filter((col: any) => !["btn"].includes(col.key)), // Editor cannot see Salary
  };
  const handleSearch = () => {
    if (searchText !== "") {
      setSearch(true);
      setPagination((prev) => ({
        ...prev,
        current: 1,
      }));
      fetchCancelledPractices(1, pagination.pageSize, "id", "asc");
    }
  };
  const clearSearch = () => {
    setSearchText("");
    // setSelectDropdownValue(undefined)
    setPagination((prev) => ({
      ...prev,
      current: 1,
    }));
  };
  useEffect(() => {
    if (searchText === "" && search === true) {
      setSearch(false);
      fetchCancelledPractices(1, pagination.pageSize, "id", "asc");
    }
  }, [searchText, search]);

  const handleSearchSelect = (value: any) => {
    setHasMore(true);
    if (value === "") {
      setData([]);
      fetchData(1, paginationPractice.pageSize, sort.field, sort.order, value);
    } else {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        fetchData(
          1,
          paginationPractice.pageSize,
          sort.field,
          sort.order,
          value
        );
      }, 500);
    }
  };

  return (
    <div className="users-container">
      <div className="section-header">
        <div className="title">
          {total > 0 && (
            <h2 className="section-title">
              {title} ({total})
            </h2>
          )}
        </div>

        <div className="practice-dropdown-container">
          {/* <Select
                        loading={isLoading}
                        value={selectedDropdownValue}
                        style={{ width: 200 }}
                        onChange={handleChange}
                        fieldNames={{ label: 'practiceName', value: 'id' }}
                        options={medicalPractices}
                    /> */}
          <Select
            showSearch
            allowClear
            value={selectedDropdownValue}
            placeholder="Select Practice"
            optionFilterProp="label"
            style={{ width: "200px" }}
            onChange={handleChange}
            filterOption={false}
            onSearch={handleSearchSelect}
            loading={loading}
            onPopupScroll={handlePopupScroll} // Infinite scrolling inside dropdown
            dropdownRender={(menu) => (
              <>
                {menu}
                {loading && (
                  <div style={{ textAlign: "center", padding: "8px" }}>
                    <Spin size="small" />
                  </div>
                )}
              </>
            )}
          >
            &nbsp;&nbsp;
            {data.map((item: any, index: any) => (
              <Option key={index} value={item.value}>
                {item.label}
              </Option>
            ))}
          </Select>
          &nbsp;&nbsp;
          <Input
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: "200px", marginRight: 8 }}
          />
          <Button
            type="primary"
            style={{ height: "31.6px" }}
            icon={<SearchOutlined rev={undefined} />}
            onClick={handleSearch}
          >
            Search
          </Button>
          &nbsp;&nbsp;
          <Button
            onClick={clearSearch}
            style={{ height: "31.6px" }}
            icon={<DeleteOutlined rev={undefined} />}
          >
            Clear
          </Button>
          &nbsp;&nbsp;
        </div>
      </div>

      <div className="table-container">
        {!rerender && (
          <Table
            rowKey="id"
            bordered
            loading={isLoading}
            columns={roleBasedColumns[currentUser?.roleId] || columns}
            dataSource={searchResults}
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              total: pagination.total,
              showSizeChanger: false,
            }}
            scroll={{ y: "calc(100vh - 270px)", x: 100 }}
            onChange={handleTableChange}
          />
        )}

        {rerender && <Table loading />}
      </div>
    </div>
  );
}

export default CancelledSurvey;
